var map = {
	"./app.js": "./src/store/modules/app.js",
	"./cache.js": "./src/store/modules/cache.js",
	"./errorLog.js": "./src/store/modules/errorLog.js",
	"./permission.js": "./src/store/modules/permission.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./tagsView.js": "./src/store/modules/tagsView.js",
	"./user.js": "./src/store/modules/user.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync recursive \\.js$";